export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4825.627b9807.jpg";